export default __webpack_public_path__ + "static/media/double-caret-vertical.d8e1bbba.svg";